// actual text element group named as "inline"
export const text = {
  group: 'inline'
}
